import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { AcompanhamentoMeusService } from '../acompanhamento-meus.service';
import { AcompanhamentoInativacaoComponent } from 'src/app/acompanhamento/acompanhamento-inativacao/acompanhamento-inativacao.component';
import { PessoaAcompanhamentoConsultaDto } from 'src/app/dtos/acompanhamentos/pessoa-acompanhamento-consulta-dto';
import { ToolbarService } from 'src/app/utilitarios/toolbar.service';
import { PesquisaBaseService } from 'src/app/libs/pesquisa/pesquisa-base.service';
import { PesquisaBaseComponent } from 'src/app/libs/pesquisa/pesquisa-base/pesquisa-base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PacienteService } from 'src/app/servicos/paciente.service';
import { UsuarioService } from 'src/app/autenticacao/usuario.service';
import { ProfissionalProfissaoTipo } from 'src/app/autenticacao/modelos/usuario';
import { AcompanhamentoService } from 'src/app/servicos/acompanhamento.service';
import { tap } from 'rxjs';
import { Column, FilterSettingsModel, GridComponent, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastService } from 'src/app/libs/toast/toast.service';
import { DateRangePresetsService } from '@/app/servicos/date-range-presets.service';


@Component({
  selector: 'app-acompanhamento-meus',
  templateUrl: './acompanhamento-meus.component.html',
  styleUrls: ['./acompanhamento-meus.component.less'],
  providers: [PesquisaBaseService]
})
export class AcompanhamentoMeusComponent implements OnInit, AfterViewInit {

  columnsGeral = [
    {
      field: 'id',
      headerText: 'ID',
      width: 80,
      minWidth: 30,
      isPrimaryKey: true,
    },
    {
      field: 'pessoaNome',
      headerText: 'Paciente',
    },
    {
      field: 'estabelecimentoNome',
      headerText: 'Estabelecimento',
      visible: false
    },
    {
      field: 'cargoNome',
      headerText: 'Cargo',
      visible: false
    }
  ];

  columnsAbertura = [
    {
      field: 'aberturaData',
      headerText: 'Data',
      format: 'dd/MM/yyyy',
      type: 'date',
      width: 110,
      minWidth: 40,
      editType: 'datepickeredit'
    },
    {
      field: 'aberturaMotivo',
      headerText: 'Motivo',
    },
    {
      field: 'aberturaResponsavel',
      headerText: 'Responsável',
      width: 80,
    }
  ];

  columnsUltimaInteracao = [
    {
      field: 'ultimaInteracaoData',
      headerText: 'Data',
      format: 'dd/MM/yyyy',
      type: 'date',
      width: 110,
      minWidth: 40,
      editType: 'datepickeredit'
    },
    {
      field: 'ultimaInteracaoDataRetornoPrevisto',
      headerText: 'Retorno Previsto',
      format: 'dd/MM/yyyy',
      type: 'date',
      width: 160,
      minWidth: 40,
      editType: 'datepickeredit'
    },
    {
      field: 'ultimaInteracaoGravidade',
      headerText: 'Gravidade',
      width: 130
    },
    {
      field: 'ultimaInteracaoMotivo',
      headerText: 'Motivo',
    },
    {
      field: 'ultimaInteracaoAcaoSolicitacaoExames',
      headerText: '+Exames',
      width: 130,
      displayAsCheckBox: true
    },
    {
      field: 'ultimaInteracaoAcaoEncaminhamento',
      headerText: '+Enc',
      width: 110,
      displayAsCheckBox: true
    }
  ];

  columnsEncerramento = [
    {
      field: 'encerramentoData',
      headerText: 'Data',
      format: 'dd/MM/yyyy',
      type: 'date',
      width: 110,
      minWidth: 40,
      editType: 'datepickeredit'
    },
    {
      field: 'encerramentoMotivo',
      headerText: 'Motivo',
    },
    {
      field: 'encerramentoResponsavel',
      headerText: 'Responsável',
    }
  ];

  @ViewChild('templateGravidade', { static: true })
  templateGravidade: any;

  @ViewChild('grid')
  grid!: GridComponent;

  registros: PessoaAcompanhamentoConsultaDto[] = [];
  modelo!: FormGroup;
  submetido = false;
  filtrarPorRetorno = true;

  toolbarItens: string[] = [
    'Search', 'ExcelExport', 'CsvExport', 'PdfExport', 'Print'
  ];

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }

  constructor(private acompanhamentoMeusService: AcompanhamentoMeusService,
    private router: Router,
    private acompanhamentoService: AcompanhamentoService,
    private pacienteService: PacienteService,
    private usuarioServico: UsuarioService,
    private toast: ToastService,
    public presets: DateRangePresetsService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public toolbar: ToolbarService, private base: PesquisaBaseService) {
    acompanhamentoMeusService.setarComponente(this);
  }

  ngOnInit(): void {
    this.modelo = this.fb.group({
      datasRetorno: [[], Validators.required]
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const hoje = new Date();
      const daquiDuasSemanas = new Date();
      daquiDuasSemanas.setDate(hoje.getDate() + 14);
      
      this.modelo.controls['datasRetorno'].setValue([hoje, daquiDuasSemanas]);
 
      this.modelo.updateValueAndValidity();
    }, 200);
  }

  created() {
    ((this.grid.columns[2] as Column).columns[2] as Column).template = this.templateGravidade;
  }

  abrirTelaCheia() {
    this.atualizar();
    this.base.abrirTelaCheia();
  }

  selecionado(registro: PessoaAcompanhamentoConsultaDto) {
    const acompanhamentos = this.grid.getSelectedRecords() as PessoaAcompanhamentoConsultaDto[];

    if (acompanhamentos.length === 0) {
      return;
    }

    this.base.fechar();

    const acompanhamentoSelecionado = acompanhamentos[0];
    const pessoaId = acompanhamentoSelecionado.pessoaId;

    if (!pessoaId) {
      this.toast.showWarning('Pessoa não identificada no acompanhamento selecionado.');
      return;
    }

    if (this.usuarioServico.consultarUsuario().profissionalProfissaoTipo !== ProfissionalProfissaoTipo.Medico) {
      return;
    }

    this.router.navigate(['./atendimentos-medicos', { id: pessoaId }], { relativeTo: this.activatedRoute })
      .then((navegou) => {
        if (navegou) {
          this.pacienteService.carregarPaciente(pessoaId).subscribe({
            next: () => {
              // se necessário, lógica adicional após carregar
            },
            error: (err) => {
              const msg = err?.error?.mensagem || 'Não foi possível carregar os dados da pessoa. Tente novamente.';
              this.toast.showWarning(msg);
            }
          });
        }
      });
  }

  atualizarClick() {
    this.submetido = true;
    this.atualizar();
  }

  atualizar() {
    if (this.filtrarPorRetorno && this.modelo.invalid) {
      return;
    }

    let dataInicialRetorno: Date | undefined = undefined;
    let dataFinalRetorno: Date | undefined = undefined;

    if (this.filtrarPorRetorno) {
      const datas = this.modelo.get('datasRetorno')?.value;
      if (datas && datas.length === 2) {
        dataInicialRetorno = datas[0];
        dataFinalRetorno = datas[1];
      }
    }

    this.acompanhamentoService.listarMeusAcompanhementos({ 
      apenasAtivos: true,
      dataInicialRetorno: dataInicialRetorno,
      dataFinalRetorno: dataFinalRetorno
    })
    .subscribe((acompanhamentos) => {
      this.registros = acompanhamentos;
    });
  }

  preencherRetornoHoje() {
    const hoje = new Date();
    this.modelo.patchValue({
      datasRetorno: [hoje, hoje]
    });

    this.atualizarClick();
  }
}
